import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class ReadParametersCommand extends IRequestCommand<
  IReadParametersCommandResponse,
  ErrorDetails,
  IReadParametersCommandRequest
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;

  public setCarrierId(carrierUserId: number): void {
    this.urlSections.push('carriers');
    this.urlSections.push(`${carrierUserId}`);
    this.urlSections.push('parameters');
    this.composeUrl();
  }
}

export interface IReadParametersCommandRequest extends ICommandParameters {}

export interface IReadParametersCommandResponse extends ICommandResponse {}
